import { Box, List, ListItemButton, Stack, Toolbar, Typography } from '@mui/material';

export type ProfileSection = 'profile' | 'billing' | 'delete';

type MainProfileSidebarProps = {
  drawerWidth: number;
  selectedSection: ProfileSection;
  onSelectHome: () => void;
  onSelectProfile: () => void;
  onSelectBilling: () => void;
  onSelectDelete: () => void;
};

export const MainProfileSidebar = ({
  drawerWidth,
  selectedSection,
  onSelectHome,
  onSelectProfile,
  onSelectBilling,
  onSelectDelete,
}: MainProfileSidebarProps) => {
  return (
    <Box
      component="nav"
      sx={{
        width: { sm: drawerWidth },
        flexShrink: { sm: 0 },
        bgcolor: '#fafbfc',
        position: 'relative',
      }}
    >
      <Toolbar sx={{ justifyContent: 'center', height: '90px', px: '50px' }}>
        <Box
          component="button"
          onClick={onSelectHome}
          sx={{ border: 0, p: 0, bgcolor: 'transparent', cursor: 'pointer' }}
        >
          <Box
            component="img"
            src="https://storage.googleapis.com/dotstorming-img/main-logo.svg"
            alt="dotstorming"
            sx={{ height: 55, maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Toolbar>

      <Stack spacing={0} sx={{ pt: '50px', pb: '25px', height: 'calc(100% - 90px)', overflowY: 'auto' }}>
        <List disablePadding>
          <ListItemButton onClick={onSelectHome} sx={{ px: '50px', py: '10px', gap: 2 }}>
            <Box
              component="img"
              src="https://storage.googleapis.com/dotstorming-img/main_home.svg"
              alt="Home"
              sx={{ width: 25, height: 25 }}
            />
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>Home</Typography>
          </ListItemButton>

          <ListItemButton
            selected={selectedSection === 'profile'}
            onClick={onSelectProfile}
            sx={{ px: '50px', py: '10px', gap: 2 }}
          >
            <Box
              component="img"
              src="https://storage.googleapis.com/dotstorming-img/main_profile.svg"
              alt="Profile"
              sx={{ width: 25, height: 25 }}
            />
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>Profile</Typography>
          </ListItemButton>

          <ListItemButton
            selected={selectedSection === 'billing'}
            onClick={onSelectBilling}
            sx={{ px: '50px', py: '10px', gap: 2 }}
          >
            <Box
              component="img"
              src="https://storage.googleapis.com/dotstorming-img/main_billing.svg"
              alt="Billing"
              sx={{ width: 25, height: 25 }}
            />
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>Billing</Typography>
          </ListItemButton>

          <ListItemButton
            selected={selectedSection === 'delete'}
            onClick={onSelectDelete}
            sx={{ px: '50px', py: '10px', gap: 2 }}
          >
            <Box
              component="img"
              src="https://storage.googleapis.com/dotstorming-img/main_delete-profile.svg"
              alt="Delete"
              sx={{ width: 25, height: 25 }}
            />
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>Delete</Typography>
          </ListItemButton>
        </List>
      </Stack>
    </Box>
  );
};
